<template>
  <DModal :show-close="false" :isBgOverlay="false" :placeInTop="true" @close="onClose" :appendToBody="true"
          style="z-index: 1231231231223312" :isCloseOnEsc="true">
    <div class="d-modal" id="tasks-create-category" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2>
          <template v-if="!theEditCategory">Opret ny kategori</template>
          <template v-else>Rediger kategori</template>
        </h2>
      </div>
      <div class="d-modal__content">
        <div class="d-input-group">
          <label class="d-label">Titel</label>
          <input type="text" class="d-input" v-model="title" ref="title_input" @keyup="isTitleAlreadyCreated = false" @keyup.enter="createCategory">
          <p class="text--error" v-if="isTitleAlreadyCreated">Titel er allerede brugt</p>
        </div>
      </div>
      <div class="d-modal__buttons">
        <div>
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit"
                  @click="createCategory"
                  :class="[{'do-bttn--submit--loading': isSubmitting}, {'do-bttn--submit--disabled': title.length < 1}]">
            Opret
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../common/DModal.vue'
import docendo from '../../docendo'

export default {
  components: {DModal},
  props: {
    taskCategories: {
      type: Array,
      default: () => []
    },
    theEditCategory: {},
    schoolId: {},
    schoolYearId: {}
  },
  data () {
    return {
      title: '',
      isSubmitting: false,
      isTitleAlreadyCreated: false
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    createCategory () {
      if (this.title.length < 1) {
        return
      }
      this.isTitleAlreadyCreated = this.taskCategories.filter(cat => cat.name === this.title).length > 0
      if (this.isTitleAlreadyCreated) {
        return
      }
      this.isSubmitting = true
      // Brug taskCategories fra props i stedet for data
      let highestRank = Math.max.apply(null, this.taskCategories.map(function (item) {
        return item.rank
      }))

      // Hvis taskCategories er tomt, sæt highestRank til 0 (det betyder, at næste rank bliver 1)
      if (highestRank === -Infinity) {
        highestRank = 0
      }

      // Beregn nextRank som næste hele tal
      let nextRank = Math.ceil(highestRank + 1)
      const subjectTypes = []
      // Opret en ny kategori med nextRank som et helt tal
      docendo.createTaskCategory(this.schoolId, this.schoolYearId, this.title, nextRank, subjectTypes, success => {
        this.$emit('onNewCategory', success)
      }, failure => {
        console.log('failure')
      })
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const el = this.$refs.title_input
      if (el) {
        el.focus()
      }
    })
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.text--error {
  color: var(--danger);
}

.d-input.d-input--error {
  border: 1px solid var(--danger);
}

#tasks-create-category {
  width: 500px;
}

.d-modal__buttons {
  padding: 1rem 2rem;
  gap: 1rem
}


</style>



// WEBPACK FOOTER //
// TaskOverviewSettingsCategoriesCreate.vue?1736ac7f